module.exports = __webpack_public_path__ + "static/img/world.5beed308.jpg";